import { t } from 'i18next';
import { Box } from 'reflexbox';
import styled from 'styled-components';

import { useLocalize } from '@treams/treams-hooks';
import { CompetencyGoal, LocalizedAttributedString } from '@treams/treams-network';
import { Paragraph, QuillText } from '@treams/treams-ui';

import GoalSkillScore from './GoalSkillScore';

const StyledGoalDescription = styled(Box)`
	display: flex;
	justify-content: left;
	column-gap: 32px;
	margin: 0;
	padding: 15px;
	background: ${({ theme }) => theme.colors.white};
`;

const Criteria = ({ criteria }: { criteria: LocalizedAttributedString }) => {
	const { localize } = useLocalize();
	return (
		<>
			<Paragraph mt={3}>{t('developmentPlan.index.goalDescription.criteria')}</Paragraph>
			<Paragraph>
				<QuillText value={localize(criteria).text} />
			</Paragraph>
		</>
	);
};
const Description = ({ description }: { description: LocalizedAttributedString }) => {
	const { localize } = useLocalize();

	return (
		<Paragraph>
			<QuillText value={localize(description).text} />
		</Paragraph>
	);
};

export default function GoalDescription({ competencyGoal }: { competencyGoal: CompetencyGoal }) {
	const { competency } = competencyGoal;
	const { levels, description } = competency;

	const targetLevel = levels?.find(
		(_level, index) => index === competencyGoal.competencyLevelIndex,
	);

	return (
		<StyledGoalDescription flexDirection={['column', 'column', 'row']}>
			<Box flexGrow={1}>
				{description && <Description description={description} />}
				{targetLevel?.criteria && <Criteria criteria={targetLevel.criteria} />}
			</Box>
			<Box flexShrink={0} flexGrow={0}>
				<GoalSkillScore goalCompetency={competencyGoal} />
			</Box>
		</StyledGoalDescription>
	);
}
